<ng-template ngbModalContainer></ng-template>
<mtm-banner [bannerType]="bannerTypes.MaintenanceOnly"></mtm-banner>
<mtm-toaster></mtm-toaster>

<child-layout
  [themeOptions]="themeOptions"
  [headerInfo]="headerInfo"
  [userProfile]="userProfile"
  [campaignName]="campaignName"
  [class.nav-expanded]="isNavExpanded"></child-layout>
